(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renisa-video-moments"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.renisaCarouselReady==='true')return;
    var track=root.querySelector('.renisa-moments__track');
    var original=Array.prototype.slice.call(track ? track.querySelectorAll('[data-moment-card]') : []);
    if(!track||!original.length)return;
    root.dataset.renisaCarouselReady='true';
    var total=original.length;
    var previous=root.querySelector('.renisa-moments__arrow--prev');
    var next=root.querySelector('.renisa-moments__arrow--next');
    var cards,active,frame=0,idleTimer=0,teleporting=false;
    var reduceMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function duplicate(card){
      var copy=card.cloneNode(true);
      copy.setAttribute('aria-hidden','true');
      copy.setAttribute('data-renisa-replica','true');
      if(copy.id)copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach(function(node){node.removeAttribute('id');});
      copy.querySelectorAll('button').forEach(function(btn){btn.tabIndex=-1;});
      copy.querySelectorAll('video').forEach(function(clip){clip.preload='none';clip.autoplay=false;});
      return copy;
    }
    if(total>1){
      // Full copies before and after the originals: A..F | A..F | A..F.
      // Inserting each copy before the original first card keeps the order.
      original.forEach(function(card){track.insertBefore(duplicate(card),original[0]);});
      original.forEach(function(card){track.appendChild(duplicate(card));});
    }
    cards=Array.prototype.slice.call(track.querySelectorAll('[data-moment-card]'));
    var first=total>1?total:0;
    active=first+Math.min(2,total-1);
    if(total===1){if(previous)previous.hidden=true;if(next)next.hidden=true;}

    function offset(index){
      var card=cards[index];
      return card.offsetLeft+(card.offsetWidth/2)-(track.clientWidth/2);
    }
    function nearest(){
      var middle=track.scrollLeft+track.clientWidth/2,closest=0,distance=Infinity;
      cards.forEach(function(card,index){
        var d=Math.abs(card.offsetLeft+card.offsetWidth/2-middle);
        if(d<distance){closest=index;distance=d;}
      });
      return closest;
    }
    function select(index){
      active=index;
      cards.forEach(function(card,i){
        card.classList.toggle('is-active',index===i);
        if(index!==i){
          var video=card.querySelector('video');
          if(video&&!video.paused)video.pause();
        }
      });
    }
    function instantPosition(index){
      teleporting=true;
      track.classList.add('is-renisa-teleporting');
      select(index);
      track.scrollLeft=offset(index);
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          track.classList.remove('is-renisa-teleporting');
          teleporting=false;
        });
      });
    }
    function canonical(index){return first+(((index-first)%total)+total)%total;}
    function resetIfNeeded(){
      if(teleporting||total<2)return;
      var target=nearest();
      if(target<first||target>=first+total){
        var clip=cards[target].querySelector('video');
        if(clip&&!clip.paused)return;
        instantPosition(canonical(target));
      }else{
        select(target);
      }
    }
    function scheduleReset(){
      clearTimeout(idleTimer);
      idleTimer=setTimeout(resetIfNeeded,165);
    }
    function scrollToCard(index){
      if(index<0||index>=cards.length)return;
      select(index);
      track.scrollTo({left:offset(index),behavior:reduceMotion?'instant':'smooth'});
      scheduleReset();
    }
    function move(direction){
      if(total<2)return;
      clearTimeout(idleTimer);
      var target=active+direction;
      if(target<0||target>=cards.length){
        instantPosition(canonical(active));
        target=active+direction;
      }
      scrollToCard(target);
    }
    function trackScroll(){
      if(teleporting)return;
      if(frame)cancelAnimationFrame(frame);
      frame=requestAnimationFrame(function(){
        frame=0;
        if(!teleporting)select(nearest());
      });
      scheduleReset();
    }
    if(previous)previous.addEventListener('click',function(){move(-1);});
    if(next)next.addEventListener('click',function(){move(1);});
    track.addEventListener('scroll',trackScroll,{passive:true});
    if('onscrollend' in track)track.addEventListener('scrollend',resetIfNeeded);
    track.addEventListener('keydown',function(event){
      if(event.key==='ArrowRight'){event.preventDefault();move(1);}
      if(event.key==='ArrowLeft'){event.preventDefault();move(-1);}
    });
    track.addEventListener('click',function(event){
      var card=event.target.closest('[data-moment-card]');
      if(!card||!track.contains(card))return;
      var index=cards.indexOf(card);
      if(index<0)return;
      var button=event.target.closest('.renisa-moments__play');
      if(!button){
        if(index!==active)scrollToCard(index);
        return;
      }
      if(total>1&&(index<first||index>=first+total)){
        index=canonical(index);
        instantPosition(index);
        card=cards[index];
      }else if(index!==active){
        scrollToCard(index);
      }
      var video=card.querySelector('video');
      if(!video)return;
      if(video.paused){
        video.muted=false;
        var promise=video.play();
        if(promise&&promise.catch)promise.catch(function(){});
      }else video.pause();
    });
    cards.forEach(function(card){
      var video=card.querySelector('video');
      var button=card.querySelector('.renisa-moments__play');
      if(!video||!button)return;
      video.addEventListener('play',function(){
        cards.forEach(function(other){
          var playing=other.querySelector('video');
          if(playing&&playing!==video&&!playing.paused)playing.pause();
        });
        button.dataset.playing='true';
        button.setAttribute('aria-pressed','true');
        button.setAttribute('aria-label','Video anhalten');
      });
      video.addEventListener('pause',function(){
        button.dataset.playing='false';
        button.setAttribute('aria-pressed','false');
        button.setAttribute('aria-label','Video abspielen');
        scheduleReset();
      });
    });
    // Start in the middle copy, with real cards available on both sides.
    requestAnimationFrame(function(){instantPosition(active);});
    window.addEventListener('resize',function(){
      clearTimeout(idleTimer);
      instantPosition(canonical(active));
    });
  }
  function initAll(){document.querySelectorAll('.renisa-moments').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);
  else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
